<template>
  <div
    class="desktop-icon"
    :style="{ top: icon.y + 'px', left: icon.x + 'px', position: 'absolute' }"
    @mousedown.prevent="startDrag"
    @contextmenu.prevent="showContextMenu($event)"
    @click.stop="selectSingle"
    @dblclick="openApp"
  >
    <div class="icon-container">
      <img
        :src="icon.icon"
        alt="icon"
        :class="{ 'selected-icon': icon.selected }"
      />
      <img
        v-if="icon.shortcut"
        src="https://win98icons.alexmeub.com/icons/png/overlay_shortcut-1.png"
        alt="shortcut overlay"
        class="shortcut-overlay"
      />
    </div>
    <div
      class="label"
      :class="{ 'selected-label': icon.selected }"
    >
      {{ icon.label }}
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  icon: Object,
  allIcons: Array,
  onShowContextMenu: Function,
  onOpenApp: Function,
});

function selectSingle() {
  props.allIcons.forEach(i => i.selected = false);
  props.icon.selected = true;
}

function startDrag(e) {
  const selectedIcons = props.icon.selected
    ? props.allIcons.filter(i => i.selected)
    : [props.icon];

  if (!props.icon.selected) {
    props.allIcons.forEach(i => i.selected = false);
    props.icon.selected = true;
  }

  const offsets = selectedIcons.map(icon => ({
    icon,
    offsetX: e.clientX - icon.x,
    offsetY: e.clientY - icon.y,
  }));

  const onMouseMove = (e) => {
    offsets.forEach(({ icon, offsetX, offsetY }) => {
      let newX = e.clientX - offsetX;
      let newY = e.clientY - offsetY;

      const maxX = window.innerWidth - 70;
      const maxY = window.innerHeight - 70;

      icon.x = Math.max(0, Math.min(newX, maxX));
      icon.y = Math.max(0, Math.min(newY, maxY));
    });
  };

  const onMouseUp = () => {
    const gridSize = 70;

    offsets.forEach(({ icon }) => {
      let snapX = Math.round(icon.x / gridSize) * gridSize;
      let snapY = Math.round(icon.y / gridSize) * gridSize;

      while (props.allIcons.some(other =>
        other !== icon &&
        other.x === snapX &&
        other.y === snapY
      )) {
        snapX += gridSize;
        if (snapX >= window.innerWidth) {
          snapX = 0;
          snapY += gridSize;
        }
        if (snapY >= window.innerHeight) {
          break;
        }
      }

      icon.x = snapX;
      icon.y = snapY;
    });

    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
  };

  window.addEventListener('mousemove', onMouseMove);
  window.addEventListener('mouseup', onMouseUp);
}

function showContextMenu(event) {
  props.onShowContextMenu(props.icon, event);
}

function openApp() {
  props.onOpenApp(props.icon);
}
</script>

<style scoped>
.desktop-icon {
  width: 64px;
  text-align: center;
  font-family: 'Pixelated MS Sans Serif', sans-serif;
  font-size: 11px;
  user-select: none;
}

.icon-container {
  position: relative;
  width: 32px;
  height: 32px;
  margin: 0 auto;
}

.desktop-icon img {
  width: 32px;
  height: 32px;
  image-rendering: pixelated;
  margin-bottom: 4px;
}

.shortcut-overlay {
  position: absolute;
  bottom: -5px;
  right: 0;
  width: 12px;
  height: 12px;
  image-rendering: pixelated;
}

.label {
  padding: 2px 4px;
  color: white;
  white-space: nowrap;
}

.selected-label {
  outline: 1px dotted #000080;
  background-color: #000080;
  color: white;
}

.selected-icon {
  filter: brightness(0.4) saturate(1) hue-rotate(36deg);
}
</style>